import { createFileRoute } from '@tanstack/react-router'
import { Outlet } from '@/libs/router'

export const Route = createFileRoute('/_authenticated/tasks/workflows')({
	component: () => <Outlet />,
})
